import Grid from "@mui/material/Grid";
import { DocumentReferenceResponse } from "api/generatedApi";

import { useTranslation } from "react-i18next";
import type { DialogBaseProps } from "shared/dialog/types";
import { DocumentRow } from "./document-row";
import { Button, Dialog, DialogActions, DialogContent, Typography, SvgIcon } from "@mui/material";
import DialogTitleStyled from "components/shared/dialog/dialog-title-styled";
import { useSortDocuments } from "./hooks/use-sort-documents";

interface Props extends DialogBaseProps {
  documents: DocumentReferenceResponse[];
  allowDownloads: boolean;
  header?: string;
  canDeleteDocument: () => boolean; // function to check if the document can be deleted
  deleteClicked?: (event: React.MouseEvent<HTMLButtonElement>) => void; // function to handle document deletion
  textColor?: string; // optional prop to set text color
}

export const UploadDialog = (props: Props) => {
  const { t } = useTranslation();
  const { header, canDeleteDocument, allowDownloads } = props;
  const sortDocuments = useSortDocuments();

  return (
    <Dialog maxWidth="sm" open={props.isOpen}>
      <DialogTitleStyled title={t(header ?? "content.showMore.docTitle")} onClose={props.onClose} isOpen={props.isOpen} />
      <DialogContent>
        <Grid container>
          {props.documents && props.documents.length > 0 ? (
            sortDocuments(props.documents).map((doc) => <DocumentRow textColor={props.textColor} key={doc.documentId} allowDownload={allowDownloads} document={doc} canDeleteDocument={canDeleteDocument} />)
          ) : (
            <Typography variant="body1" color="grey.100">
              {t("content.overview.documents.noDocuments")}
            </Typography>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={props.onClose}>
          {t("common.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
